import React from "react";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiGithub,
  FiLinkedin,
} from "react-icons/fi";
import "./footer.css";
import { motion } from "framer-motion/dist/framer-motion";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="footer-links"
        >
          <div className="footer-links_contacts">
            <h1 className="footer-headtext">Contact Me</h1>
            <p>Put Address Over Here</p>
            <p>+123 456 7890</p>
            <p>+123 456 7890</p>
          </div>
          <div className="footer-links_logo">
            <h1>The TechVerse</h1>
            <p>"Help Me discover the Unknown and Space"</p>
            <div className="footer-links_icons">
              <a href="https://www.linkedin.com/in/bilal-zakari-9399a0220/">
                <FiLinkedin />
              </a>
              <a href="https://github.com/BillZak">
                <FiGithub />
              </a>
              <a href="https://web.facebook.com/bill.zak.589/">
                <FiFacebook />
              </a>
              <a href="https://www.instagram.com/champ_gobain/">
                <FiInstagram />
              </a>
              <a href="https://twitter.com/BillZak3">
                <FiTwitter />
              </a>
            </div>
          </div>
          <div className="footer-links_work">
            <h1 className="footer-headtext">Services</h1>
            <p>Careers</p>
            <p>Help Center</p>
            <p>Hire Me</p>
          </div>
        </motion.div>
        <div className="footer__copyright">
          <p>Built With Love By Bill Zack, 2022</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
